<template>
  <div>
    <!-- choose prefered otpion block -->
    <template v-if="!selectedOption || selectedOption.length <= 0 ">
      <v-row
        dense
        justify="start"
        class="elevation-1 px-3 mx-1 py-4 my-5 grey lighten-2"
      >
        <v-col cols="12">
          <h3 class="pa-3">
            {{ asGroup ? $t("conflict.whatIsYourFavoriteGroupOfOptionsIfYouAddMoreInfo") : $t("conflict.whatIsYourFavoriteOptionIfYouAddMoreInfo") }}
          </h3>
        </v-col>
        <v-col cols="12">
          <wigo-chip
            v-for="option in availableOptions"
            :key="option.map(opt => opt.id).join('-')"
            :wigo="option"
            :outlined="option !== selectedOption"
            @click.native="selectOption(option)"
            :asGroup="asGroup"
          />
        </v-col>
      </v-row>
    </template>
    <!-- ask for more info/elements block -->
    <template v-else>
      <v-row
        dense
        justify="start"
        class="elevation-1 px-3 mx-1 py-4 my-5 grey lighten-2"
      >
        <v-col cols="12">
          <h3 class="pa-3">{{ canYouAddElementToPrefer }}</h3>
        </v-col>
        <v-col cols="12">
          <wigo-chip
            :wigo="selectedOption"
            :asGroup="asGroup"
          />
        </v-col>
        <v-col cols="12">
          <input-scenario-elements
            :available-elements="availableElements"
            :update-available-elements="updateElementList"
            create-new-scenario
            :validate-scenarii="validateInformation"
            :add-element-list="addElementList"
            v-on="$listeners"
          />
        </v-col>
      </v-row>

    </template>

    <v-row justify="center">
      <raison-button
        v-if="scenarioOfLevel2OrMore"
        :button-label="$t('global.finish')"
        :button-function="filterScenarioForW2"
        :loading="buttonFinishLoading"
        :disabled="buttonFinishLoading"
      >
        <template v-slot:append>
          <v-icon right>mdi-arrow-right</v-icon>
        </template>
      </raison-button>
    </v-row>
  </div>
</template>

<script>
import RaisonButton from "@/components/global/RaisonButton";
import scenarioService from "@/services/scenarios.js";
import elementService from "@/services/elements.js";
import believeService from '@/services/believes.js';
import optionService from "@/services/options.js";
import InputScenarioElements from "@/components/global/InputScenarioElements";
import WigoChip from '@/components/global/WigoChip.vue';
import {IsCohereService} from '@/services/isCohere.js'

export default {
  name: "Option2Workflow",

  components: { RaisonButton, InputScenarioElements, WigoChip },

  data() {
    return {
      selectedOption: [],
      loadingElements: false,
      argueBelief: false,
      elements: [],
      selectedElements: [],
      createdPreferences: [],
      preferencesOfScenario: [],
      createdTodos: [],
      buttonFinishLoading: false,
      currentGroupId: null,
    };
  },

  props: {
    availableOptions: {
      type: Array,
      required: true,
    },
    currentScenario: {  
      type: Object,
      required: true,
    },
    preferenceList: {
      type: Array,
      required: true,
    },
    scenarioOfLevel2OrMore: {
      type: Array,
      required: false,
    },
    chosenOption: {
      type: [Array, Object],
      required: false,
    },
    beliefMode: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  computed: {

    asGroup() {
      return !!this.currentGroupId;
    },

    // return preferences related to the selected scenario
    scenarioPreferences() {
      const scenarioPreferences = this.preferenceList
        .filter(pref => pref.scenario.id === this.currentScenario.id);
      console.log('scenarioPreferences', scenarioPreferences, this.currentScenario.id);
      return scenarioPreferences;
    },

    canYouAddElementToPrefer() {
      let label = 'conflict.canYouAddElementToPrefer';
      if(this.asGroup) {
        label = 'conflict.canYouAddElementToPreferThisGroup';
      }
      else if(this.beliefMode) {
        label = 'conflict.canYouAddElementToPreferForBelief';
      }
      return this.$t(label);
    },

    wigoProperty() {
      return believeService.wigoProperty(this.beliefMode);
    },

    logoProperty() {
      return believeService.logoProperty(this.beliefMode);
    },

    availableElements() {
      if (this.currentScenario && this.currentScenario.elements && this.currentScenario.elements.length) {
        let currScenarioElementsId = this.currentScenario.elements.map(elt => elt.id);
        return this.elements.filter(elt => !currScenarioElementsId.includes(elt.id));
      }
      return this.elements;
    },

    // non selected options
    otherOptions() {
      const selectedOptionIds = this.selectedOption.map(o=>o.id).sort().join(",");
      return this.availableOptions.filter(option => {
        if (this.selectedOption.length) { // check if is an array
          let optionIds = option.map(opt=>opt.id).sort().join(",");
          return optionIds !== selectedOptionIds;
        }
        return false;
      });
    }
  },

  methods: {
    log(msg) {
      console.log(msg);
    },
    selectOption(option) {
      this.selectedOption = option;
    },

    validateInformation(elements) {
      this.createdTodos = []
      this.callingApi = true;
      const todo = {
        scenario: this.currentScenario,
        todo: "f_4.2_02(S)",
        from : 'case2',
        preferedOptions : this.selectedOption,
        availableGroups : [this.selectedOption, ...this.otherOptions],
        currentGroupId: this.currentGroupId
      };

      this.$emit("addTodo", todo);
      this.selectedElements.splice(0, this.selectedElements.length, ...elements);
      
      //Here we start algorithme
      let originalScenario = Object.assign({}, this.currentScenario);
      console.log("GetScenarioEnabledOptions(S) = ", this.availableOptions);
      console.log("btn validé");
      console.log('selectedOption ',this.selectedOption);
      console.log('otherOptions',this.otherOptions);
      //newS = < elements(S union Form.new_elements),level(S)+1, true, {S}, {}>
      let newS = {
        id: '$ref1',
        extend: true,
        name: 'Comes from workflow 2',
        level: +this.currentScenario.level + 1,
        elements: [
          ...this.currentScenario.elements, 
          ...this.selectedElements],
      };
      // create new scenario
      // newS = copy of S
      console.log('currentGroupId', this.currentGroupId)
      const preferences = this.otherOptions
        .map(logo => {
          // find previous preference
          const logoIds = logo.map(opt => opt.id);
          const selectedOptionIds = this.selectedOption.map(opt => opt.id);
          const wigoOrLogo = [...logoIds, ...selectedOptionIds];
          const previousPreference = this.scenarioPreferences
            .filter(pref => wigoOrLogo.includes(...pref[this.wigoProperty].map(opt => opt.id)))
            .map(pref => pref.id);

          let preference = {
            name: 'created in workflow 2',
            groupId: this.currentGroupId,
            scenario: newS,
            previousPreferences: previousPreference,
          };
          if(this.beliefMode) {
            preference = {
              ...preference,
              wigoBelief: this.selectedOption.map(opt => { return { id: opt.id }}),
              logoBelief: logo.map(opt => { return { id: opt.id }}),
            };
          }
          else {
            preference = {
              ...preference,
              wigo: this.selectedOption.map(opt => { return { id: opt.id }}),
              logo: logo.map(opt => { return { id: opt.id }}),
            };
          }
          return preference;
        });

      scenarioService.createPreferences(this.$route.params.id, preferences)
        .then(rep => {
          rep.data.forEach(pref => this.$emit("addPreferenceToList", pref));
          this.createdPreferences.push(...rep.data);

          this.currentGroupId = rep.data[0].groupId; // all preferences have the same groupId
          this.$emit('groupCreated', this.currentGroupId);
          // For each Pn where scenario(Pn) = newS
          const newSId = rep.data[0].scenario.id;

          const preferenceswithnewSc = rep.data;

          IsCohereService.$on('addTodo', todo => {
            if (!this.isTodoAlreadyCreated(todo)) {
              console.log('isCohereService: adding todo', todo);
              this.$emit('addTodo', todo)
              this.createdTodos.push(todo)
            }
            else {
              console.log('todo already existing', todo);
            }
          })
          IsCohereService.searchCoherentScenarios(preferenceswithnewSc, this.preferenceList, originalScenario, newSId, this.beliefMode);
          IsCohereService.$off('addTodo')

          this.$emit("nextTodo")
        })
        .catch(err => {
          this.$emit("raison-event", {type: "error", messages: [err]});
        })
        .finally(() => {
          this.selectedOption = []
        });

    },

    // executeWorkflow(pref,newSId,originalScenario){
    //   // SP = SP union P = <{oi}, {oj}, newS>
    //   return scenarioService.createScenarioPreference(this.$route.params.id,newSId, pref)
    //     .then(rep => {
    //       this.$emit("addPreferenceToList", rep.data);
    //       this.createdPreferences.push(rep.data);

    //       // For each Pn where scenario(Pn) = newS
          
    //       let preferenceswithnewSc = this.createdPreferences.filter(pref => pref.scenario.id === newSId);
          
    //       IsCohereService.$on('addTodo', todo => {
    //         if (!this.isTodoAlreadyCreated(todo)) {
    //           console.log('isCohereService: adding todo', todo);
    //           this.$emit('addTodo', todo)
    //           this.createdTodos.push(todo)
    //         }
    //         else {
    //           console.log('todo already existing', todo);
    //         }
    //       })
    //       IsCohereService.searchCoherentScenarios(preferenceswithnewSc, this.preferenceList, originalScenario, newSId, this.beliefMode);
    //       IsCohereService.$off('addTodo')
    //     });
    // },

    loadElements(loadBelief) {
      this.loadingElements = true;
      elementService.getElements(this.$route.params.id).then(res => {
        this.elements = res.data;
        if (loadBelief) {
          this.loadBelief();
        }
      }).catch(err => {
        this.$emit("raison-event", { type: "error", messages: [err] });
      }).finally(() => {
        this.loadingElements = false;
      });
    },

    addElementList(element) {
      this.selectedElements = element;
    },

    updateElementList(elts) {
      this.elements.splice(0, this.elements.length, ...elts);
    },

    loadOptionScenarios(option) {
      this.callingApi = true;
      this.loadingScenarios = true;
      optionService.getOptionScenarios(this.$route.params.id, option.id).then(res => {
        const responseScenarios = res.data;
        let minimalScenarios = responseScenarios.filter(sce => sce.level === 1);
        this.$set(option, "scenarii", minimalScenarios);
      }).catch(err => {
        this.$emit("raison-event", { type: "error", messages: [err] });
      }).finally(() => {
        this.loadingScenarios = false;
        this.callingApi = false;
      });
    },

    filterScenarioForW2() {
      console.log("algo finiSh");
      this.buttonFinishLoading = true;
      //canExtend(S)=false
      console.log("canExtend(S)=false");
      let allScenarios = scenarioService.getAllScenarios(this.preferenceList);
      let allDescendantsScenarios = scenarioService.getAllDescendants(this.currentScenario, allScenarios);
      // TODO improve with bulk API update for scenarios
      allDescendantsScenarios.forEach(descendantScenario => {
        this.$emit("addTodo", {
          scenario: descendantScenario,
          todo: "extends false",
        });
      })
      this.$emit("addTodo", {
        scenario: this.currentScenario,
        todo: "extends false",
      });
      this.$emit("nextTodo");
      const todo = {
        scenario: this.currentScenario,
        todo: "f_4.2_02(S)",
        case2: 2
      };
      if(!this.currentGroupId?.startsWith('$')) {
        todo.currentGroupId = this.currentGroupId;
      }
      this.$emit("addTodo", todo);
      this.$emit("nextTodo");
      this.buttonFinishLoading = false;
    },

    isTodoAlreadyCreated (checkedTodo) {
      if (checkedTodo.todo !== 'f_4_2_08') return false;
      return this.createdTodos
        .filter(todo => todo.todo === 'f_4_2_08')
        .find(todo => {
          return (
            (todo.piPref.id === checkedTodo.piPref.id && todo.pjPref.id === checkedTodo.pjPref.id)
            || (todo.piPref.id === checkedTodo.pjPref.id && todo.pjPref.id === checkedTodo.piPref.id)
          )
        }) !== undefined
    },

    canBeUnified(pn, pm, sj) {
      /*
    console.log('rta start check')
    console.log('rta pm elements', pm.scenario.elements.map(element => element.name).join(','))
    console.log('rta pn elements', pn.scenario.elements.map(element => element.name).join(','))
    console.log('rta pm.wigo.length > 0', pm.wigo.length > 0)
    console.log('rta pn.wigo.length > 0', pn.wigo.length > 0)
    console.log('rta && pn.logo.length > 0', pn.logo.length > 0)
    console.log('rta pm.logo.length > 0', pm.logo.length > 0)
    console.log('rta pm.scenario.id === sj.id', pm.scenario.id === sj.id)
    if (pm.logo[0]) {
      console.log('rta pm.wigo[0].id === pn.logo[0].id', pm.wigo[0].id === pn.logo[0].id)
      console.log('rta pn.wigo[0].id === pm.logo[0].id', pn.wigo[0].id === pm.logo[0].id)
      console.log('rta pn.wigo[0]', pn.wigo[0].name)
      console.log('rta pm.wigo[0]', pm.wigo[0].name)
      console.log('rta pn.logo[0]', pn.logo[0].name)
      console.log('rta pm.logo[0]', pm.logo[0].name)
    }
    console.log('rta go to isCohere -> ', pm.wigo.length > 0
    && pm.logo.length > 0
    && pn.wigo.length > 0
    && pn.logo.length > 0
    && pm.scenario.id === sj.id 
    && pm.wigo[0].id === pn.logo[0].id 
    && pn.wigo[0].id === pm.logo[0].id)
    console.log('rta end check')
    */
      return pm.wigo.length > 0
        && pm.logo.length > 0
        && pn.wigo.length > 0
        && pn.logo.length > 0
        && pm.scenario.id === sj.id 
        && pm.wigo.map(w => w.id).sort().join('-') === pn.logo.map(w => w.id).sort().join('-')
        && pn.wigo.map(w => w.id).sort().join('-') === pm.logo.map(w => w.id).sort().join('-')
    },
  },

  mounted() {
    if(this.chosenOption && this.chosenOption.length > 0) {
      this.selectedOption.splice(0,this.selectedOption.length, ...this.chosenOption);
    }
    if (!this.$route.params.beliefId || ! this.beliefMode) {
      this.loadElements();
    } else {
      this.argueBelief = true;
      this.loadElements(true);
    }
  },
};
</script>
